module.exports = __webpack_public_path__ + "static/media/update_black_24dp.6bdc88c4.svg";